import { connect } from 'react-redux';
import { 
	closeModalAction
} from '../flickr-redux/actions';
import Modal from './Modal';

const mapStateToProps = (state) => {
	return {
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		dispatchCloseModal: () => {
			dispatch(closeModalAction());
		}
	}
}

const ModalContainer = connect(mapStateToProps, mapDispatchToProps)(Modal);

export default ModalContainer;



/** WEBPACK FOOTER **
 ** ./src/modal/ModalContainer.js
 **/